import { ProductCart } from '@ecommerce/shared'
import React from 'react'
import { Container, InputsContainer, Title } from './styled'
import { useProductCustomization } from '../../components/CustomizableInput/useProductCustomization'
import CustomizableInput from '../../components/CustomizableInput/CustomizableInput'

interface CustomizableInputsProps {
  product: ProductCart
}

const CustomizableInputs = ({ product }: CustomizableInputsProps) => {
  const { customValues, errors, handleInputChange, handleSave } = useProductCustomization(product)

  if (!product || product.quantity <= 0) {
    return null
  }

  return (
    <Container>
      <Title>Personaliza tu producto</Title>

      <InputsContainer>
        {Array.from({ length: product.quantity }).map((_, index) => {
          const currentValue = customValues[index]
          const originalValue = product.customUnitNames?.[index]

          return (
            <CustomizableInput
              key={`custom-input-${index}`}
              name={`custom-input-${index}`}
              ariaLabel={`Personalización para unida ${index + 1}`}
              placeholder="Ingresa el nombre de tu personalización"
              value={currentValue}
              error={errors[index]}
              isSaved={!!originalValue}
              isDisabled={!!errors[index] || currentValue === originalValue}
              onChange={(value) => handleInputChange(index, value)}
              onSave={() => handleSave(index)}
            />
          )
        })}
      </InputsContainer>
    </Container>
  )
}

export default CustomizableInputs
